import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";
import { EnvConstants } from "../../common/Constants";

export interface TPaymentConfirmation {
  id: number;
  type: string;
  processingDate: Date;
  amount: number;
  description: string;
  senderAccount: string;
  receiverAccount: string;
  senderName?: string;
  receiverName?: string;
  sourceCurrency?: string;
  destinationCurrency?: string;
  paymentReference?: string;
  urgent?: string;
  taxPayerId?: string;
  paymentType?: string;
  revenueType?: string;
  taxPeriodFrom?: string;
  taxPeriodTo?: string;
  municipality?: string;
  budgetaryUnit?: string;
  taxRefNumber?: string;
  bicCode?: string;
  bankName?: string;
  address?: string;
  address2?: string;
  coverageAmount?: number;
  coverageCurrency?: string;
  expensesBaredBy?: string;
  paymentPurpose?: string;
  buyAmount?: number;
  coverageAccount?: string;
  abroadExecutionTime?: string;
}

export interface IPaymentConfirmation extends TPaymentConfirmation {
  paymentPurposeVisible(): boolean;
  paymentReferenceVisible(): boolean;
}

const PaymentConfirmation = Model(
  (model: TPaymentConfirmation): IPaymentConfirmation => {
    const _paymentConfirmation: TPaymentConfirmation = Object.assign({}, model);

    const create = (
      paymentConfirmation: IPaymentConfirmation
    ): IPaymentConfirmation => {
      const obj = ValidatableObject(paymentConfirmation);
      return obj;
    };

    const paymentConfirmation = {
      get id() {
        return _paymentConfirmation.id;
      },
      set id(value) {
        _paymentConfirmation.id = value;
      },
      get type() {
        return _paymentConfirmation.type;
      },
      set type(value) {
        _paymentConfirmation.type = value;
      },
      get processingDate() {
        return _paymentConfirmation.processingDate;
      },
      set processingDate(value) {
        _paymentConfirmation.processingDate = value;
      },
      get amount() {
        return _paymentConfirmation.amount;
      },
      set amount(value) {
        _paymentConfirmation.amount = value;
      },
      get description() {
        return _paymentConfirmation.description;
      },
      set description(value) {
        _paymentConfirmation.description = value;
      },
      get senderAccount() {
        return _paymentConfirmation.senderAccount;
      },
      set senderAccount(value) {
        _paymentConfirmation.senderAccount = value;
      },
      get receiverAccount() {
        return _paymentConfirmation.receiverAccount;
      },
      set receiverAccount(value) {
        _paymentConfirmation.receiverAccount = value;
      },
      get senderName() {
        return _paymentConfirmation.senderName;
      },
      set senderName(value) {
        _paymentConfirmation.senderName = value;
      },
      get receiverName() {
        return _paymentConfirmation.receiverName;
      },
      set receiverName(value) {
        _paymentConfirmation.receiverName = value;
      },
      get sourceCurrency() {
        return _paymentConfirmation.sourceCurrency;
      },
      set sourceCurrency(value) {
        _paymentConfirmation.sourceCurrency = value;
      },
      get destinationCurrency() {
        return _paymentConfirmation.destinationCurrency;
      },
      set destinationCurrency(value) {
        _paymentConfirmation.destinationCurrency = value;
      },
      get paymentReference() {
        return _paymentConfirmation.paymentReference;
      },
      set paymentReference(value) {
        _paymentConfirmation.paymentReference = value;
      },
      get urgent() {
        return _paymentConfirmation.urgent;
      },
      set urgent(value) {
        _paymentConfirmation.urgent = value;
      },
      get taxPayerId() {
        return _paymentConfirmation.taxPayerId;
      },
      set taxPayerId(value) {
        _paymentConfirmation.taxPayerId = value;
      },
      get paymentType() {
        return _paymentConfirmation.paymentType;
      },
      set paymentType(value) {
        _paymentConfirmation.paymentType = value;
      },
      get revenueType() {
        return _paymentConfirmation.revenueType;
      },
      set revenueType(value) {
        _paymentConfirmation.revenueType = value;
      },
      get taxPeriodFrom() {
        return _paymentConfirmation.taxPeriodFrom;
      },
      set taxPeriodFrom(value) {
        _paymentConfirmation.taxPeriodFrom = value;
      },
      get taxPeriodTo() {
        return _paymentConfirmation.taxPeriodTo;
      },
      set taxPeriodTo(value) {
        _paymentConfirmation.taxPeriodTo = value;
      },
      get municipality() {
        return _paymentConfirmation.municipality;
      },
      set municipality(value) {
        _paymentConfirmation.municipality = value;
      },
      get budgetaryUnit() {
        return _paymentConfirmation.budgetaryUnit;
      },
      set budgetaryUnit(value) {
        _paymentConfirmation.budgetaryUnit = value;
      },
      get taxRefNumber() {
        return _paymentConfirmation.taxRefNumber;
      },
      set taxRefNumber(value) {
        _paymentConfirmation.taxRefNumber = value;
      },
      get bicCode() {
        return _paymentConfirmation.bicCode;
      },
      set bicCode(value) {
        _paymentConfirmation.bicCode = value;
      },
      get bankName() {
        return _paymentConfirmation.bankName;
      },
      set bankName(value) {
        _paymentConfirmation.bankName = value;
      },
      get address() {
        return _paymentConfirmation.address;
      },
      set address(value) {
        _paymentConfirmation.address = value;
      },
      get address2() {
        return _paymentConfirmation.address2;
      },
      set address2(value) {
        _paymentConfirmation.address2 = value;
      },
      get coverageAmount() {
        return _paymentConfirmation.coverageAmount;
      },
      set coverageAmount(value) {
        _paymentConfirmation.coverageAmount = value;
      },
      get coverageCurrency() {
        return _paymentConfirmation.coverageCurrency;
      },
      set coverageCurrency(value) {
        _paymentConfirmation.coverageCurrency = value;
      },
      get expensesBaredBy() {
        return _paymentConfirmation.expensesBaredBy;
      },
      set expensesBaredBy(value) {
        _paymentConfirmation.expensesBaredBy = value;
      },
      get paymentPurpose() {
        return _paymentConfirmation.paymentPurpose;
      },
      set paymentPurpose(value) {
        _paymentConfirmation.paymentPurpose = value;
      },
      get buyAmount() {
        return _paymentConfirmation.buyAmount;
      },
      set buyAmount(value) {
        _paymentConfirmation.buyAmount = value;
      },
      get coverageAccount() {
        return _paymentConfirmation.coverageAccount;
      },
      set coverageAccount(value) {
        _paymentConfirmation.coverageAccount = value;
      },
      get abroadExecutionTime() {
        return _paymentConfirmation.abroadExecutionTime;
      },
      set abroadExecutionTime(value) {
        _paymentConfirmation.abroadExecutionTime = value;
      },
      paymentPurposeVisible() {
        return import.meta.env.VITE_PAYMENT_PURPOSE === EnvConstants.TRUE;
      },
      paymentReferenceVisible() {
        return import.meta.env.VITE_PAYMENT_REFERENCE === EnvConstants.TRUE;
      }
    };

    return create(paymentConfirmation);
  }
);

export default PaymentConfirmation;
